// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./components/dashboard";
import PortfolioPage from "./components/PortfolioPage";
import Aboutus from "./components/aboutus";
import Contactus from "./components/contactus";
import MediaGalleryPage from "./components/MediaGalleryPage";
import ServicePage from "./components/ServicePage";
import Certificate from "./components/Certificate";
import PartnerPage from "./components/PartnerPage";



const App = () => {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<Dashboard />} />
        <Route path="/:id" caseSensitive={false} element={<PortfolioPage />} />
        <Route path="/aboutus" caseSensitive={false} element={<Aboutus />} />
        <Route path="/contactus" caseSensitive={false} element={<Contactus />} />
        <Route path="/:id/gallery" caseSensitive={false} element={<MediaGalleryPage />} />
        <Route path="/:id/service" caseSensitive={false} element={<ServicePage />} />
        <Route path="/:id/certificate" caseSensitive={false} element={<Certificate />} />
        <Route path="/partnerpage" caseSensitive={false} element={<PartnerPage />} />

      </Routes>
    </Router>
  );
};

export default App;
